export default __webpack_public_path__ + "static/activities_image_six_mobile-78b3a542d1e5adee4041068f0c84671d.jpg";